export interface CameraDeviceLike {
  label: string;
}

const EXACT_REAR_CAMERA_LABELS = new Set([
  "back camera",
  "zadna kamera",
  "rear camera",
  "world facing camera",
]);

const REAR_CAMERA_HINTS = ["back", "rear", "world", "environment", "zadn"];
const FRONT_CAMERA_HINTS = ["front", "predn", "user", "selfie", "facetime", "true depth", "truedepth"];
const TELEPHOTO_HINTS = ["telephoto", "teleobj", "zoom"];
const ULTRA_WIDE_HINTS = ["ultra wide", "ultrawide", "0.5x", "fisheye", "ultrasiroko"];
const MAIN_CAMERA_HINTS = ["wide", "main", "standard", "1x", "sirokouhly"];

export function normalizeCameraLabel(label: string): string {
  return label
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();
}

function includesAny(text: string, phrases: string[]): boolean {
  return phrases.some(phrase => text.includes(phrase));
}

function getCameraScore(label: string, index: number): number {
  const normalizedLabel = normalizeCameraLabel(label);
  let score = 100 - index;

  if (!normalizedLabel) {
    return score;
  }

  if (EXACT_REAR_CAMERA_LABELS.has(normalizedLabel)) {
    score += 10000;
  }

  if (includesAny(normalizedLabel, REAR_CAMERA_HINTS)) {
    score += 4000;
  }

  if (includesAny(normalizedLabel, MAIN_CAMERA_HINTS) && !includesAny(normalizedLabel, ULTRA_WIDE_HINTS)) {
    score += 500;
  }

  if (includesAny(normalizedLabel, FRONT_CAMERA_HINTS)) {
    score -= 6000;
  }

  if (includesAny(normalizedLabel, TELEPHOTO_HINTS)) {
    score -= 3500;
  }

  if (includesAny(normalizedLabel, ULTRA_WIDE_HINTS)) {
    score -= 2500;
  }

  return score;
}

export function getPreferredCameraIndex(devices: CameraDeviceLike[]): number {
  if (devices.length === 0) {
    return -1;
  }

  let bestIndex = 0;
  let bestScore = getCameraScore(devices[0].label, 0);

  for (let index = 1; index < devices.length; index += 1) {
    const score = getCameraScore(devices[index].label, index);
    if (score > bestScore) {
      bestIndex = index;
      bestScore = score;
    }
  }

  return bestIndex;
}
